import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["period", "startDate", "endDate"]
  static values = { url: String, frame: String }

  periodChanged() {
    const period = this.periodTarget.value
    if (period === "custom") return

    const dates = this.calculateDates(period)
    this.startDateTarget.value = dates.start
    this.endDateTarget.value = dates.end
  }

  reload() {
    const startDate = this.startDateTarget.value
    const endDate = this.endDateTarget.value
    const period = this.periodTarget.value

    if (!startDate || !endDate) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("start_date", startDate)
    url.searchParams.set("end_date", endDate)
    url.searchParams.set("period", period)

    const frame = document.getElementById(this.frameValue)
    if (frame) {
      frame.src = url.toString()
    } else {
      window.location.href = url.toString()
    }
  }

  calculateDates(period) {
    const today = new Date()
    const year = today.getFullYear()
    const month = today.getMonth()
    const day = today.getDate()
    let start, end

    switch (period) {
      case "0": // Previous Month
        start = new Date(year, month - 1, 1, 12)
        end = new Date(year, month, 0, 12)
        break
      case "1": // Current Month
        start = new Date(year, month, 1, 12)
        end = new Date(year, month, day, 12)
        break
      case "2": // This Quarter
        const quarterStart = month - (month % 3)
        start = new Date(year, quarterStart, 1, 12)
        end = new Date(year, month, day, 12)
        break
      case "3": // Last 6 Months
        start = new Date(year, month - 6, 1, 12)
        end = new Date(year, month, day, 12)
        break
      case "4": // Last Year
        start = new Date(year - 1, month, 1, 12)
        end = new Date(year, month, day, 12)
        break
      default:
        start = new Date(year, month - 1, 1, 12)
        end = new Date(year, month, 0, 12)
    }

    return {
      start: this.formatDate(start),
      end: this.formatDate(end)
    }
  }

  formatDate(date) {
    return date.toISOString().substring(0, 10)
  }
}
